module.exports = __webpack_public_path__ + "img/bottom_outer_box_bg.3905ee05.png";